import { useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import React from 'react';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';
import { graphql, useFragment } from 'utils/graphClient';
import { ManageVaultFieldsModal } from '../ManageVaultFieldsModal';
import { ManageVaultFieldsOption_node$key } from './__generated__/ManageVaultFieldsOption_node.graphql';
import { createIcon } from 'components/icons/createIcon';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';

export const ManageVaultFieldIcon = createIcon(light('screwdriver-wrench'));

const nodeFragment = graphql`
  fragment ManageVaultFieldsOption_node on Node {
    id
    ... on Vault {
      __typename
      canUpdate {
        value
      }
    }
  }
`;

interface ManageVaultFieldsOptionProps {
  node: ManageVaultFieldsOption_node$key;
}

export const ManageVaultFieldsOption = ({
  node,
}: ManageVaultFieldsOptionProps) => {
  const { __typename, id, canUpdate } = useFragment(nodeFragment, node);
  const { isOpen, onOpen, onClose } = useDisclosure();

  if (__typename !== 'Vault' || !canUpdate?.value) return null;

  return (
    <>
      <OptionsMenuItem icon={<ManageVaultFieldIcon />} onClick={onOpen}>
        {t`Manage fields`}
      </OptionsMenuItem>

      <ManageVaultFieldsModal isOpen={isOpen} onClose={onClose} vaultId={id} />
    </>
  );
};
